import { Heading, RecommendedTimeIcon, Skeleton } from '@buffer-mono/popcorn'

import { transformScheduleIntoPostingTimePreview } from '../../helpers/transformScheduleIntoPostingTimePreview'
import type { GetPostingSchedulePreviewPayload } from '../../hooks/usePostingSchedulePreview'

import styles from './PostingTimePreview.module.css'

import type { JSX } from 'react'

interface PostingTimePreviewProps {
  loading?: boolean
  data?: GetPostingSchedulePreviewPayload
}

export const PostingTimePreview = ({
  loading = true,
  data,
}: PostingTimePreviewProps): JSX.Element => {
  if (loading) {
    return (
      <div className={styles.schedulePreview}>
        <Skeleton width="100%" height="56px" />
        <Skeleton width="100%" height="56px" />
        <Skeleton width="100%" height="56px" />
      </div>
    )
  }

  if (!data) {
    return (
      <div className={styles.schedulePreview}>
        <p>No data available</p>
      </div>
    )
  }

  return (
    <div className={styles.schedulePreview}>
      {transformScheduleIntoPostingTimePreview(
        data.postingSchedulePreview.proposed ?? [],
      ).map((slot) => (
        <div
          className={styles.schedulePreviewItem}
          key={`${slot.day}-${slot.startTime}`}
        >
          <Heading
            as="h4"
            size="sm"
            className={styles.schedulePreviewItemTitle}
            icon={<RecommendedTimeIcon />}
          >
            {slot.day} from <strong>{slot.startTime}</strong> to{' '}
            <strong>{slot.endTime}</strong>
          </Heading>
        </div>
      ))}
    </div>
  )
}
